/**
 * Capitalizes the first letter of each word, delimited by spaces or hyphens.
 * @param {string} str
 * @return {string}
 */
export const capitalize = str => str
  .split(/([-\s]+)/)
  .map((wordOrDelimiter, index) => index % 2 === 1
    ? wordOrDelimiter
    : `${wordOrDelimiter[0].toUpperCase()}${wordOrDelimiter.slice(1)}`
  ).join('');